import { Component, Input, OnInit } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb'; 
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';

@Component({
  selector: 'atw-text-price-admin-config',
  templateUrl: './text-price-admin-config.component.html',
  styleUrls: ['./text-price-admin-config.component.scss']
})
export class AtwTextPriceAdminConfig extends AtwUpdateDbComponent implements OnInit {
@Input() data_tool: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() type_config : string; // xác định trang đang ở page hay preview
  // @Input() id_subproject : any;
  @Input() objectChoosing: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() device: any // xác định trang ở thiết bị desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database

  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  isCollapsed: boolean = false;
  styles_field = [
    {
      title: 'Cấu hình hiệu ứng',
      index: 1,
    }
  ];

  fonts = [];
  effect_hover = [];
  effect_hover_data: any = {};
  none: boolean = false; // có chọn PHONG CÁCH hay chưa (true=>chưa; false:đã chọn)
  dataAfterChange: any  = {};
  arr_link_page: any;
  id_subproject: any = "";
  configMode: 'basic' | 'advanced' = 'basic';
  // private textFormatDiffer: KeyValueDiffer<string, any>;
  /** Biến lưu cấu hình tự động dịch có đang bật không? Tránh gọi hàm getSetups_byFields quá nhiều lần */
  private isAutoTranslate: boolean;
  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient, 
    public vhEventMediator: VhEventMediator,
        public functionService: FunctionService
  ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }

  ngOnInit(): void {
    this.vhQueryAutoWeb.getSetups_byFields({ type: { $in: ['auto_translate_language'] } })
      .then((res: any) => {
        this.isAutoTranslate = res.find((ele) => ele.type == 'auto_translate_language').auto_translate_language;
      });
    
    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/fonts/fonts.json'),
      this.http.get('assets/data/effects/text.json'), 
    ]) .subscribe(([fonts, effects]:any)=>{
      this.fonts = fonts;
      this.effect_hover = effects;
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
    })

    // duynguyen: tại sao click vào phải updateDB?
    // Kiểm tra đã chọn Phong cách hay chưa
    // if(!this.class['text-price__content']['text-shadow']
    //   && !this.class['text-price']['background-color']
    //   && this.class['text-price__content']['-webkit-text-stroke-width'] == 0) {
    //     this.dispatchStyles('');
    // }
  }

  ngOnChanges(): void {
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type'])
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }  
  }

  

  /**
   * Cập nhật text-shadow
   */
  handleSetTextShadow() {
    this.class['text-price__content']['text-shadow'] = `${this.config['text-shadow']['offset_x']}px ${this.config['text-shadow']['offset_y']}px ${this.config['text-shadow']['blur_radius']}px ${this.config['text-shadow']['shadow_color']}`;
  }

  togglePriceIs0(event) {
    this.config.price_is_0 ??= {}; 
    this.config.price_is_0.enable = event; 
    this.updateConfig();
  }

  /** Định dạng hiệu ứng văn bản (phong cách và kiểu cọ)
   * @param action : trả về hiệu ứng văn bản đã chọn
   */
  dispatchStyles(action) {
    // reset những style khác trước
    switch (action) {
      case 'Đổ bóng':
        this.class['text-price__content']['-webkit-text-stroke-width'] = "0";
        this.class['text-price']['background-color'] = "";
        this.class['text-price']['border-top-left-radius'] = "0%";
        this.class['text-price']['border-top-right-radius'] = "0%";
        this.class['text-price']['border-bottom-right-radius'] = "0%";
        this.class['text-price']['border-bottom-left-radius'] = "0%";

        this.handleSetTextShadow();
        this.none = false
        break;
      case 'Tạo stroke':
        this.class['text-price__content']['text-shadow'] = "";
        this.class['text-price']['background-color'] = "";
        this.class['text-price']['border-top-left-radius'] = "0%";
        this.class['text-price']['border-top-right-radius'] = "0%";
        this.class['text-price']['border-bottom-right-radius'] = "0%";
        this.class['text-price']['border-bottom-left-radius'] = "0%";

        this.class['text-price__content']['-webkit-text-stroke-width'] = '3px'
        this.none = false
        break;
      case 'background':
        this.class['text-price__content']['-webkit-text-stroke-width'] = "0";
        this.class['text-price__content']['text-shadow'] = "";

        this.class['text-price']['background-color'] = "#008848";
        this.none = false
        break;
      default:
        this.class['text-price__content']['-webkit-text-stroke-width'] = "0";
        this.class['text-price__content']['text-shadow'] = "";
        this.class['text-price']['background-color'] = "";
        this.class['text-price']['border-top-left-radius'] = "0%";
        this.class['text-price']['border-top-right-radius'] = "0%";
        this.class['text-price']['border-bottom-right-radius'] = "0%";
        this.class['text-price']['border-bottom-left-radius'] = "0%";
        this.none = true;
    }

    this.updateObject();
  }


  customize = []
  
  // /**
  //  * Hàm update object vào database.
  //  */
  // updateObject() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
  //     .then((bool: any) => {
        
  //     })
  // }

  // /**
  //  * Hàm update class
  //  */
  // updateClass() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
  //     .then((bool: any) => {
        
  //     })
  // }

  // /**
  //  * Hàm update config
  //  */
  // updateConfig() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
  //     .then((bool: any) => {
        
  //     })
  // }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại. 
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false
  };
 
  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.styles_field[0])
  }

  /**
   * Update nội dung 
   * @param fieldContent - Tên trường để cập nhật nội dung
   * @param isAriaLabel - Có phải là trường dạng aria-label không
   * @example
   * data = [ { langCode: 'vi', translatedText: 'Bản đồ Việt Nam' } ]
   */
  updateContent(fieldContent, isAriaLabel = false) {
    if (this.isAutoTranslate) {
      this.functionService.translateToMultipleLanguages(
        isAriaLabel 
        ? this.staticdata.accessibility?.[`${fieldContent}_${this.functionService.selectedLanguageCode}`]
        : this.staticdata[`${fieldContent}_${this.functionService.selectedLanguageCode}`]
      )
      .subscribe({
        next: (data) => {
          // console.log('data', data)
          this.functionService.multi_languages.forEach(lang => {
            // Trường hợp là content nằm trong staticdata và nằm bằng cấp với accessibility
            if (!isAriaLabel) {
              if (
                this.functionService.selectedLanguageCode != lang.code 
                && !this.staticdata[`${fieldContent}_${lang.code}`]
              ) {
                this.staticdata[`${fieldContent}_${lang.code}`] = data.find(
                  item => item.langCode == lang.code
                ).translatedText;
              }
            } 
            // Trường hợp là field nằm trong accessibility
            else {
              if (
                this.functionService.selectedLanguageCode != lang.code 
                && !this.staticdata.accessibility?.[`${fieldContent}_${lang.code}`]
              ) {
                this.staticdata.accessibility[`${fieldContent}_${lang.code}`] = data.find(
                  item => item.langCode == lang.code
                ).translatedText;
              }
            }
          });
          this.updateStaticData();
        },
        error: (err) => {
          console.error('Lỗi dịch thuật:', err);
        }
      });
    } else {
      this.updateStaticData();
    }
  }
}
